<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{
        'pricing.partner.priceHistory.title'
          | translate: { bundle: bundle()?.name }
      }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <app-data-table
          [configuration]="dataTableConfiguration"
        ></app-data-table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="modalRef.close()">
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #priceColumnTemplate let-bundle="row">
  @if (bundle.price) {
    <div class="caption">
      {{ bundle.price }} {{ pricingPartner()?.currency }}
    </div>
  } @else {
    <div class="caption text-danger">
      {{ 'pricing.partner.details.missingPrice' | translate }}
    </div>
  }
</ng-template>

<ng-template #generatedByColumnTemplate let-bundle="row">
  @if (bundle.generatedBy) {
    <span class="caption">
      <app-user-display [userId]="bundle.generatedBy" />
    </span>
  }
</ng-template>
